const midColumn = () => ({
	name: "mid",
	type: "input" as const,
	placeholder: "MID",
});

export default midColumn;
